export default __webpack_public_path__ + "static/media/codefi2.431cd0b9.png";